export const calculateFrameFaceTextureRepeat = ({
  frameWidth,
  imageWidth,
  imageHeight,
}) => {
  const dimensions = [frameWidth, imageWidth, imageHeight];

  if (
    dimensions.some(
      (dimension) => !Number.isFinite(dimension) || dimension <= 0,
    )
  ) {
    throw new RangeError("Frame and texture dimensions must be positive");
  }

  // ExtrudeGeometry's face UVs use world coordinates, so one complete image
  // height requires the inverse of the rendered rail width.
  const repeatY = 1 / frameWidth;
  const imageAspect = imageWidth / imageHeight;

  return {
    x: repeatY / imageAspect,
    y: repeatY,
  };
};
